export default "__VITE_ASSET__D96PQGCC__"